export default {
  envTitleColor: Styles.color.grey.one,
};
